module.exports = __webpack_public_path__ + "static/wave-7d55f80ff3bb14c22fe1155c9c1abcd7.png";